import Container from "../../components/Layout/Container"
import { Row, Col } from "react-bootstrap"
import styles from "./ExhibitionDetailsPage.module.css"
import { HelmetTitle } from "../../components/Layout/HelmetTitle"
import { imageResizer } from "../../../services/utils/imageResizer"
import { SeoTags } from "../../components/Layout/SeoTags"
import { HeadingTitle } from "../../components/Layout/HeadingTitle"
import Wrapper from "../../components/Layout/Wrapper"
import Nav from "react-bootstrap/Nav"
import Link from "next/link"
import { linksBuilder } from "../../../services/utils/linksBuilder"

const ExhibitionsDetailsPage = ({ exhibitionDetails }) => {
  const title = `${exhibitionDetails.title} in ${exhibitionDetails.gallery.name} | Discover ArtPlacer`
  return (
    <>
      <Wrapper>
        <SeoTags
          title={`${exhibitionDetails.title} | Discover ArtPlacer`}
          description={`Check out ${exhibitionDetails.title} from ${exhibitionDetails.gallery.name}. ${exhibitionDetails.description}`}
          image={imageResizer(exhibitionDetails.image, 340, `AUTO`)}
          url={`https://discover.artplacer.com/exhibitions/${exhibitionDetails.id}`}
          canonical={`https://discover.artplacer.com/exhibitions/${exhibitionDetails.id}`}
        />
        <HelmetTitle title={title} />
        <Container>
          <Row>
            <Col className="mx-1">
              <HeadingTitle title={exhibitionDetails.title}>
                {exhibitionDetails.author}
              </HeadingTitle>
              <Nav className="mb-3">
                <div className="nav-item">
                  <Link
                    href="/galleries"
                    className="text-black text-decoration-underline pr-1 font-primary fs-14px">
                    Galleries
                  </Link>
                </div>
                <div className="nav-item">/</div>
                <div className="nav-item">
                  <Link
                    href="/galleries/[id]"
                    as={linksBuilder.galleries(
                      exhibitionDetails.gallery.domain,
                    )}
                    className="text-black text-decoration-underline px-1 font-primary fs-14px">
                    {exhibitionDetails.gallery.name}
                  </Link>
                </div>
              </Nav>
            </Col>
          </Row>
          <Row>
            <div className="container">
              <div className={styles.iframeContainer}>
                <iframe
                  width="100%"
                  height="100%"
                  frameborder="0"
                  allowfullscreen=""
                  src={
                    process.env.NEXT_PUBLIC_ASSESTS_URL +
                    "virtual-exhibitions/index.html?i=" +
                    exhibitionDetails.id
                  }></iframe>
              </div>
            </div>
          </Row>
        </Container>
      </Wrapper>
    </>
  )
}

export default ExhibitionsDetailsPage
